import React from "react";
import PartnerHeader from "../../component/PartnerHeader";
import PartnerFooter from "../../component/PartnerFooter";

function TrainerRequests() {
  const requests = [
    {
      trainer: "Rahul Sharma",
      skill: "Java DSA",
      date: "22 Aug 2026",
      status: "PENDING",
    },
    {
      trainer: "Amit Kumar",
      skill: "Python",
      date: "21 Aug 2026",
      status: "APPROVED",
    },
  ];

  return (
    <>
    <PartnerHeader/>
    <div className="page">
      <h1>Trainer Requests</h1>
      <p>Manage your trainer requests.</p>

      <div className="card">
        <table>
          <thead>
            <tr>
              <th>Trainer</th>
              <th>Skill</th>
              <th>Date</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {requests.map((item, index) => (
              <tr key={index}>
                <td>{item.trainer}</td>
                <td>{item.skill}</td>
                <td>{item.date}</td>
                <td>
                  <span className={`status ${item.status.toLowerCase()}`}>
                    {item.status}
                  </span>
                </td>
                <td>
                  <button>View</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <style>{`
        .page {
          padding:30px;
          background:#f8fafc;
          min-height:100vh;
        }

        .page p {
          color:#64748b;
        }

        .card {
          background:white;
          padding:20px;
          border-radius:12px;
          margin-top:25px;
          overflow:auto;
        }

        table {
          width:100%;
          border-collapse:collapse;
        }

        th,td {
          padding:13px;
          border-bottom:1px solid #e2e8f0;
          text-align:left;
        }

        th {
          background:#f8fafc;
        }

        .status {
          padding:5px 10px;
          border-radius:20px;
          font-size:11px;
          font-weight:bold;
        }

        .pending {
          background:#fef3c7;
          color:#92400e;
        }

        .approved {
          background:#dcfce7;
          color:#166534;
        }

        button {
          border:0;
          background:#2563eb;
          color:white;
          padding:7px 14px;
          border-radius:6px;
        }
      `}</style>
    </div>
    <PartnerFooter/>
    </>
  );
}

export default TrainerRequests;